import { Box, Typography } from "@material-ui/core"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import styled from "styled-components"

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 40px;
  line-height: 0.8;
  text-align: right;
  height: 40px;
  color: #000;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 40px;
    line-height: 1;
    height: 40px;
  }
`

const StyledBox = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    button {
      width: 50%;
    }
  }
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  line-height: 0.8;
  text-align: right;
  margin-top: 5px;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
    height: 24px;
  }
`

const StyledButton = styled(Box)<{ $isSelected?: boolean }>`
  width: 150px;
  height: 48px;
  background-color: ${(p) => (p.$isSelected ? "#264f36" : "#f7f7f7")};
  color: ${(p) => (p.$isSelected ? "#fff" : "#757575")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "NarkisBlock", sans-serif;
  font-size: 24px;
  font-weight: bold;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    height: 48px;
    margin-left: 10px;
    margin-top: 12px;
    font-family: "NarkisBlock", sans-serif;
  }

  :hover {
    border: 2px solid ${(p) => p.theme.colors.darkYellow};
  }
`
const StyledLabel = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`

const SingelButtonWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 35px;
  }
  margin-top: 20px;
`

type BalanceHeaderProps = {
  setSwitcher: React.Dispatch<React.SetStateAction<number>>
  setGiftCardError: React.Dispatch<React.SetStateAction<string>>
}

const BalanceHeader = ({
  setSwitcher,
  setGiftCardError,
}: BalanceHeaderProps) => {
  const buttons = [
    { value: 0, text: " לפי מס’ טלפון" },
    { value: 1, text: "  לפי מס’ גיפטקארד" },
  ]

  const handleButtonClick = (code) => {
    setSwitcher(code)
    setGiftCardError(null)
  }

  return (
    <StyledBox>
      <StyledTitle>בירור היתרה שלי</StyledTitle>
      <StyledText>
        כאן אפשר לברר כמה כסף נשאר לנצל או לנהל חשבון לאיסוף מתנה משותפת
      </StyledText>
      <SingelButtonWrapper>
        <SingleButtonSelection
          aria-label="בירור יתרה לפי מספר טלפון או מספר גיפטקארד"
          id="routesSelect"
          items={buttons.map((amount, index) => ({
            value: amount.value,
            name: amount.text,
            ariaLabel:
              index === 0
                ? "בדיקת יתרה לפי מספר טלפון"
                : "בדיקת יתרה לפי מספר גיפטקארד",
          }))}
          onSelect={(code) => handleButtonClick(code)}
          gap={15}
          itemsPerRow={"auto"}
          customButton={(radioId, isSelected, item) => {
            return (
              <>
                <StyledLabel htmlFor={radioId} $activeButton={isSelected}>
                  <StyledButton $isSelected={isSelected}>
                    <>{item.name}</>
                  </StyledButton>
                </StyledLabel>
              </>
            )
          }}
        />
      </SingelButtonWrapper>
    </StyledBox>
  )
}

export default BalanceHeader
